import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiPost, ApiError } from "../api/client";

interface RevokeWorkerResponse {
  ok: boolean;
  code: "OK_WORKER_REVOKED";
}

export interface RevokeWorkerPayload {
  worker_id: number;
}

export function useRevokeWorker() {
  const qc = useQueryClient();
  return useMutation<RevokeWorkerResponse, ApiError, RevokeWorkerPayload>({
    mutationFn: ({ worker_id }) =>
      apiPost(`/api/admin/workers/${worker_id}/revoke`, {}),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["workers"] }),
  });
}
